// DS1.7.13
import React from 'react';
const DAProtectIndicator = ({ variant , className  })=>{
    switch(variant){
        case 'temporary':
            return /*#__PURE__*/ React.createElement("svg", {
                className: className,
                width: "24",
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 24 25"
            }, /*#__PURE__*/ React.createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5 6.09 12 3l7 3.09v4.637a9.584 9.584 0 0 1-.629 3.389 5.503 5.503 0 0 0-4.364 5.098A8.428 8.428 0 0 1 12 20c-4.044-1.005-7-5.023-7-9.273V6.091Zm5.938 9.745-.175.165H9v-1.636l1.777-3.152-.145-.165H9V8.8h2.968l.262-.164.832-1.471.176-.165H15v1.636l-1.777 3.153.145.164H15V14.2h-2.968l-.262.164-.832 1.471Z",
                fill: "currentColor"
            }), /*#__PURE__*/ React.createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17 18c.074 1.286.804 2.444 1.786 2.793.208.128.357.386.357.698 0 .312-.149.57-.357.698-.982.35-1.712 1.525-1.786 2.811h5c-.074-1.305-.804-2.462-1.786-2.811-.208-.129-.357-.386-.357-.698 0-.313.149-.57.357-.698.982-.35 1.712-1.507 1.786-2.793h-5Z",
                fill: "#00E59B"
            }));
        case 'inactive':
            return /*#__PURE__*/ React.createElement("svg", {
                className: className,
                width: "24",
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 24 24"
            }, /*#__PURE__*/ React.createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 3L5 6.09091V10.7273C5 14.9773 7.95556 18.9955 12 20C12.3544 19.912 12.7004 19.8008 13.0368 19.6684C13.0125 19.449 13 19.2259 13 19C13 15.7808 15.5352 13.1538 18.7179 13.0065C18.9022 12.2656 19 11.5003 19 10.7273V6.09091L12 3ZM10.7626 16L10.9385 15.8353L11.7703 14.3638L12.0317 14.1999H15V11.9527H13.3682L13.2229 11.7894L15 8.63636V7H13.2375L13.0615 7.16459L12.2299 8.63621L11.9684 8.79997H9V11.0473H10.6318L10.7771 11.2116L9 14.3635V16H10.7626Z",
                fill: "currentColor"
            }), /*#__PURE__*/ React.createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.6964 19.1647C22.6102 21.1317 20.9883 22.7 19 22.7C17.6895 22.7 16.5381 22.0187 15.8808 20.991L22.6964 19.1647ZM22.3924 17.5207L15.323 19.415C15.3078 19.2787 15.3 19.1403 15.3 19C15.3 16.9565 16.9565 15.3 19 15.3C20.5175 15.3 21.8216 16.2136 22.3924 17.5207ZM24 19C24 21.7614 21.7614 24 19 24C16.2386 24 14 21.7614 14 19C14 16.2386 16.2386 14 19 14C21.7614 14 24 16.2386 24 19Z",
                fill: "#F53948"
            }));
        case 'active':
            return /*#__PURE__*/ React.createElement("svg", {
                className: className,
                width: "24",
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 24 24"
            }, /*#__PURE__*/ React.createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5 6.09 12 3l7 3.09v4.637a9.584 9.584 0 0 1-.629 3.389 5.503 5.503 0 0 0-4.364 5.098A8.428 8.428 0 0 1 12 20c-4.044-1.005-7-5.023-7-9.273V6.091Zm5.938 9.745-.175.165H9v-1.636l1.777-3.152-.145-.165H9V8.8h2.968l.262-.164.832-1.471.176-.165H15v1.636l-1.777 3.153.145.164H15V14.2h-2.968l-.262.164-.832 1.471Z",
                fill: "currentColor"
            }), /*#__PURE__*/ React.createElement("path", {
                d: "m16.5 20 1.225-1.286 2.017 1.715L22.775 17 24 18.286 19.742 23 16.5 20Z",
                fill: "#00E59B"
            }));
        default:
            return null;
    }
};
DAProtectIndicator.displayName = 'DAProtectIndicator';
export default DAProtectIndicator;
